export * from './score-challenge-slider';